__turbopack_context__.v({
  "styleGuideContainer": "style-guide-module-scss-module__jeGD2a__styleGuideContainer",
});
